import Grid from '@/roc/grid/Grid';
import BuildingType from "@/roc/building/BuildingType";
import BuildingLevel from "@/roc/building/BuildingLevel";
import { useLayoutStore } from "@/roc/stores/LayoutStore";
import { useApplicationStore } from "@/roc/stores/ApplicationStore";
import EraType from "@/roc/era/EraType";
import { ref } from "vue";
export default function () {
    const lytStore = useLayoutStore();
    const gridCells = ref([]);
    const appStore = useApplicationStore();
    const placeCityHall = () => {
        const template = lytStore.getBuildingTemplateByType(BuildingType.CITY_HALL);
        if (!template) {
            return;
        }
        lytStore.placeBuilding(template, {
            x: Grid.CELL_COUNT_X - template.width,
            y: 0,
            rotate: false,
            level: BuildingLevel.calculateMaxLevel(template, appStore.selectedEra || EraType.stoneAge),
            era: appStore.selectedEra || EraType.stoneAge
        });
    };
    return {
        gridCells,
        buildGrid() {
            for (let x = 0; x <= Grid.CELL_SIZE * Grid.CELL_COUNT_X; x += Grid.CELL_SIZE) {
                gridCells.value.push({
                    position: x,
                    mode: 'vertical'
                });
            }
            for (let y = 0; y <= Grid.CELL_SIZE * Grid.CELL_COUNT_Y; y += Grid.CELL_SIZE) {
                gridCells.value.push({
                    position: y,
                    mode: 'horizontal'
                });
            }
            if (lytStore.isLayoutEmpty()) {
                placeCityHall();
            }
        }
    };
}
